<template>
    <div>
        <div class="flex-align-center title_div">
            <img :src="path"/>
            <div class="flex-align-center flex-between">
                <h1 style="font-size: 16px;">{{title}}&nbsp;&nbsp;&nbsp;&nbsp;{{subtitle}}</h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TitleLabel",
    props: {
        title:String,
        subtitle:String,
        path:String,
    },
    data(){
        return{

        }
    }
}
</script>

<style lang="less" scoped>
@import "../../views/style/base.less";
.title_div {
    margin-top: 10px;
    margin-left: 10px;
    height: 100%;
    img {
        margin-right: .4rem;
        width: 24px;
        height: 24px;
    }
    div {
        width: 100%;
    }
    h1 {
        text-align: center;
        font-size: 1.2rem;
        color: @base_textColor;
    }
}
</style>